<template>
  <v-container>
    <div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col>
            <div v-if="!edit" class="display-1">Ny profil</div>
            <div v-else class="display-1">Ret profil</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Fornavn"
                  dense
                  required
                  :rules="nameRules"
                  v-model="newUser.firstName"
                ></v-text-field>
                <v-text-field label="Mellemnavn(e)" dense v-model="newUser.middleName"></v-text-field>
                <v-text-field
                  label="Efternavn"
                  dense
                  required
                  :rules="nameRules"
                  v-model="newUser.lastName"
                ></v-text-field>
                <v-text-field
                  v-mask="'######-####'"
                  label="CPR"
                  persistent-hint
                  hint="Undlad evt. de sidste fire cifre ved ansatte."
                  dense
                  v-model="newUser.cpr"
                ></v-text-field>
                <v-checkbox v-model="newUser.active" label="Aktiv"></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-row align="center" justify="center">
                  <v-avatar color="grey" size="140" v-if="newUser.firstName">
                    <span class="white--text display-3">
                      {{ newUser.firstName | initials
                      }}{{ newUser.lastName | initials }}
                    </span>
                  </v-avatar>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-if="functions"
                  :items="functions"
                  item-text="funktion"
                  item-value="id"
                  label="Funktion"
                  v-model="newUser.function"
                  required
                  :rules="nameRules"
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-if="classes"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  label="Hold"
                  clearable
                  v-model="newUser.class"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      required
                      :rules="numberRules"
                      v-mask="'## ## ## ##'"
                      label="Tlf"
                      type="tel"
                      dense
                      v-model="newUser.number"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="E-mail" type="email" dense v-model="newUser.email"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8">
                    <v-text-field label="Gade" dense v-model="newUser.address.street"></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field label="Nr" dense v-model="newUser.address.no"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3">
                    <v-text-field
                      v-mask="'####'"
                      label="Postnummer"
                      dense
                      v-model="newUser.address.code"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field label="By" dense v-model="newUser.address.city"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-checkbox label="Admin" input-value="true" value v-model="newUser.admin"></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-show="newUser.function == '7mzJwXQe4KnKOQ7Gqovb'">
              <v-col>Sagsbehandler: {{ newUser.caseworker }}</v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </v-container>
</template>

<script>
//import * as firebase from 'firebase/app';
//import { diff}  from "json-diff";

export default {
  props: ["save", "newUser", "edit", "profile"],
  filters: {
    initials: function(value) {
      if (value) {
        let first = value.charAt(0).toUpperCase();
        return first;
      }
    }
  },
  created() {
    this.$store.dispatch("GET_CLASSES");
    this.$store.dispatch("GET_FUNCTIONS");
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("cancel");
      }
    };
  },

  computed: {
    classes() {
      return this.$store.state.classes;
    },

    functions() {
      return this.$store.state.functions;
    },
    functionName() {
      if (this.functions && this.profile.function) {
        let functionName = this.functions.find(obj => {
          return obj.id === this.profile.function;
        });
        return functionName.funktion;
      }
      return null;
    }
  },
  data() {
    return {
      valid: true,

      nameRules: [v => !!v || "Dette felt er påkrævet"],
      cprRules: [
        v => v.replace(/\s/g, "").length == 13 || "CPR skal være 12 cifre."
      ],
      numberRules: [
        v => !!v || "Dette felt er påkrævet",
        v => (v && v.length == 11) || "Nummeret skal være otte cifre."
      ],
      emailRules: value => {
        if (value.length > 0) {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
